import { Users, CheckCircle } from "lucide-react";

export default function About() {
  const stats = [
    { value: "20+", label: "Years Experience" },
    { value: "200+", label: "Happy Clients" },
    { value: "2004", label: "Est. Year" },
    { value: "100%", label: "Qualified" },
  ];

  return (
    <section
      id="about"
      className="py-16 md:py-24 bg-white overflow-x-hidden"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          
          {/* Left: BakerKerry panel */}
          <div className="flex justify-center">
            <div className="w-full max-w-[350px] sm:max-w-[400px] md:max-w-full h-auto md:aspect-[4/5] rounded-3xl bg-gradient-to-br from-purple-500 to-violet-700 flex flex-col items-center justify-center p-4 sm:p-6 md:p-10 shadow-2xl">
              <div className="text-white/20 text-5xl sm:text-6xl md:text-7xl font-black select-none mb-4 sm:mb-6">
                BakerKerry
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl md:text-6xl font-bold text-white">
                  20+
                </div>
                <div className="text-purple-200 mt-1 sm:mt-2 text-sm sm:text-base md:text-lg">
                  Years of Excellence
                </div>
              </div>
              <div className="mt-4 sm:mt-6 md:mt-10 flex flex-col gap-2 sm:gap-3 w-full">
                {["Est. 2004", "FCCA Qualified", "200+ Clients"].map((badge) => (
                  <div
                    key={badge}
                    className="bg-white/10 text-white rounded-xl px-3 py-2 sm:px-4 sm:py-2 text-center text-xs sm:text-sm font-medium tracking-wide"
                  >
                    {badge}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: content */}
          <div>
            <div className="text-purple-600 text-xs sm:text-sm font-semibold tracking-widest uppercase mb-2 sm:mb-3">
              About Us
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 leading-snug sm:leading-tight mb-4 sm:mb-6">
              Trusted Accountants You Can Rely On
            </h2>
            <p className="text-slate-500 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
              Founded in 2004, BakerKerry Accountants has built a reputation for delivering expert, personalised accountancy services to individuals and businesses of all sizes. Our partners are both fully qualified chartered certified accountants with over two decades of hands-on experience.
            </p>
            <p className="text-slate-500 text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8">
              We pride ourselves on building long-lasting relationships with our clients, offering clear, honest advice and a proactive approach to managing your finances.
            </p>

            {/* Partners */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-6 sm:mb-8">
              {["Mrs M Baker", "Mrs N Kerry"].map((partner) => (
                <div
                  key={partner}
                  className="flex items-center gap-3 bg-purple-50 rounded-xl px-4 py-2 sm:px-5 sm:py-3 w-full sm:w-auto flex-shrink-0"
                >
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center">
                    <Users size={16} className="text-purple-600" />
                  </div>
                  <div>
                    <div className="font-semibold text-slate-800 text-sm">{partner}</div>
                    <div className="text-xs text-slate-400">
                      Chartered Certified Accountant (FCCA)
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Features */}
            <div className="space-y-2 sm:space-y-3">
              {[
                "Fully qualified chartered certified accountants",
                "Tailored advice for every client",
                "Transparent, competitive pricing",
              ].map((f) => (
                <div
                  key={f}
                  className="flex items-center gap-2 sm:gap-3 text-slate-600 text-sm sm:text-base"
                >
                  <CheckCircle size={16} className="text-purple-500 flex-shrink-0" />
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mt-12 md:mt-20">
          {stats.map((s) => (
            <div
              key={s.label}
              className="text-center p-6 md:p-8 rounded-2xl bg-slate-50 border border-slate-100"
            >
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-purple-600">
                {s.value}
              </div>
              <div className="text-slate-500 text-xs sm:text-sm md:text-sm mt-1 md:mt-2">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}